import React, { useEffect, Fragment, useContext } from 'react';
import { getToken } from './tokenHelper';
import { getLoginUrlRequest } from '../reducers/Auth/actions';

const LoginPage = props => {
  const { context } = props;
  const store = useContext(context);
  const state = store.getState();
  const { settings } = state;
  const { location } = state.router;
  const { loginRedirectUrl } = settings;

  useEffect(() => {
    if (getToken() === null && location.state !== undefined) {
      const { nextPathname } = location.state;
      if (nextPathname !== '/login' && nextPathname !== '/callback') {
        localStorage.setItem('redirectUrl', loginRedirectUrl || nextPathname);
        store.dispatch(getLoginUrlRequest({ settings }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, getLoginUrlRequest, location]);

  return <Fragment />;
};

export default LoginPage;
